import {ApiResourceEnum} from 'app/interface/api-resource.interface';

export const MethodTypeMapping = new Map<string, string>([
    [ApiResourceEnum.Method, 'methode'],
    [ApiResourceEnum.MethodGroup, 'groep'],
    [ApiResourceEnum.Chapter, 'blok'],
    [ApiResourceEnum.Paragraph, 'hoofdstuk'],
    [ApiResourceEnum.ItemMap, 'les'],
]);
